export default {
    PL001: 'PLACE_NOT_FOUND',
    PL002: 'PLACE_ID_SHOULD_BE_UUID',
    PL003: 'NAME_IN_USE',
    PL005: 'SLUG_ALREDY_EXISTS',
};
